var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_content"},[_c('job-header',{attrs:{"uuid":_vm.uuid}}),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"page-content-section"},[_c('div',{staticClass:"left-container"},[_c('div',{staticClass:"job-page-title ace_sec_txt"},[_vm._v(_vm._s(_vm.$tf('reports')))])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c219ba68","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/job/components/JobReports.vue
// module id = null
// module chunks = 